export default __webpack_public_path__ + "58b9b0a8113faefa3f98974ffed92029.png";